// extracted by mini-css-extract-plugin
module.exports = {"editor":"comment_editor__h1a7j","readOnly":"comment_readOnly__7hPDX","focus":"comment_focus__Sh_7A","licenseInput":"comment_licenseInput__f78Fg"};